import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProjectModel } from 'src/app/shared/models/projectModel';

@Injectable({
  providedIn: 'root'
})
export class SelectionService {
  private selectedModelsSubject = new BehaviorSubject<ProjectModel[]>([]);
  selectedModels$ = this.selectedModelsSubject.asObservable();

  get selectedModels(): ProjectModel[] {
    return this.selectedModelsSubject.value;
  }

  setSelectedModels(models: ProjectModel[]) {
    this.selectedModelsSubject.next(models);
  }

  addModel(model: ProjectModel) {
    const models = [...this.selectedModelsSubject.value];
    if (!models.some(m => m.id === model.id)) {
      models.push(model);
      this.selectedModelsSubject.next(models);
    }
  }

  removeModel(model: ProjectModel) {
    const models = this.selectedModelsSubject.value.filter(m => m.id !== model.id);
    this.selectedModelsSubject.next(models);
  }





}
